<template>
    <div id="searchSubgenome">
        <div style="margin-left:928px;margin-top: 1px;">
            <img src="../assets/img/close.png" style="width: 24px;height: 18px" @click.self="hideSelf" title="close">
        </div>
        <h2 style="text-align: center;margin: 10px auto;color: #275015">Optional genome and subgenome</h2>
        <div id="subgenome_sheet" v-for="subgenome in target" :key="subgenome">
            <div id="subgenome">
                <button @click="SubgenomeFunctionSelection(subgenome)" class="search_gene_button">{{subgenome}}</button>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "ShowSubgenomeList",
        props: ['target', 'target1', 'target2'],
        data() {
            return {
                subgenome_list: [],
            }
        },
        mounted() {
            // this.searchsubgenome()
        },
        methods: {
            searchsubgenome() {
                
            },
            SubgenomeFunctionSelection(subgenome) {
                // console.log(subgenome)
                var gene = this.target1[this.target.indexOf(subgenome)]
                // console.log(gene)
                this.$emit("subgenomeFunctionSelection", gene)
            },
            hideSelf() {
                this.$emit("hideBox");
            },
        }
    }
</script>

<style>
    #searchSubgenome {
        position: fixed;
        width: 950px;
        height: 400px;
        background: #77B07F;
        overflow-y:auto;
        left: 0;
        right: 0;
        top: 15%;
        margin: 0 auto;
    }

    #searchSubgenome #subgenome_sheet #subgenome{
        float: left;
        text-align: center;
        width: 300px;
        margin-top: 5px;
        margin-bottom: 10px;
    }

    #searchSubgenome #subgenome_sheet #subgenome .search_gene_button {
        margin: auto;
        font-size: 20px;
        color: #ffffff;
        background: #77B07F;
        border: 0px;
        height: 40px;
    }

    #searchSubgenome #subgenome_sheet #subgenome .search_gene_button:hover {
        color: #333a61;
    }
</style>